<template>
    <div>
         <top></top>
        <div class="container evl_wp">
           <breadcrumb></breadcrumb>

            <div class="my-title">
                评价
            </div>
            <div class="order_evaluate_wp">
                <div class="order_evaluate">
                    <div class="order_">
                        <img :src="eavluate.goods_image" alt="" />
                    </div>
                    <span>{{ eavluate.goods_title }}</span>
                </div>
                <div class="evaluate_texta">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="addeavluate.content"
                    >
                    </el-input>
                </div>
            </div>
            <div class="eva_fen">
                <span>对此商品进行评分:</span>
                <el-rate
                    @change="rateEvaluate"
                    v-model="value1"
                    :texts="texts"
                    show-text
                ></el-rate>
            </div>
            <div class="eva_btn">
                <el-button type="primary" @click="submitEvaluate"
                    >点击提交</el-button
                >   
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import { orderItemDetail, orderComment } from "@/api/index.js";
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
import top from "@/components/top.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import bottom from "@/components/bottom.vue";
export default {
    // props: {
    //     value: {
    //         type: Object,
    //         default: {}
    //     }
    // },
    // watch: {
    //     value: {
    //         handler(newValue) {
    //             console.log(newValue, "new");

    //         },
    //         immediate: true,
    //         deep: true
    //     }
    // },
    created() {
        this.value = JSON.parse(this.$route.query.value);
        console.log(this.value);
        this.getOrderItemId();
    },
    data() {
        return {
            textarea: "",
            value1: 5,
            value: {},
            eavluate: {},
            texts: ["差评", "中评", "中评", "好评", "好评"],
            addeavluate: {
                id: "",
                order_item_id: "",
                level: 5,
                content: "",
                images: []
            }
        };
    },

    methods: {
        getOrderItemId() {
            console.log(this.value.orderItemId);
            orderItemDetail(
                {
                    id: this.value.orderId,
                    order_item_id: this.value.orderItemId
                },
                header
            ).then(res => {
                if (res.code !== 1) {
                    return;
                }

                this.eavluate = res.data;
            });
        },
        rateEvaluate(value) {
            this.addeavluate.level = value;
            console.log(value);
        },
        submitEvaluate() {
            console.log(this.addeavluate);
            // this.$router.go(0);
            if (this.addeavluate.content == "") {
                return this.$message.info("请填写评论");
            }

            let obj = {
                id: this.value.orderId,
                order_item_id: this.value.orderItemId,
                level: 5,
                content: this.addeavluate.content,
                images: []
            };
            orderComment(obj, header).then(res => {
                if (res.code !== 1) {
                    return this.$message.error("提交失败");
                }
                this.$message.success(res.msg);
                this.$router.push({ path: "/mine" });
            });
        }
    },
    components: {
        breadcrumb,
        top,
        bottom
    }
};
</script>
<style lang="less" scoped>
.my-title {
    // height: 40px;
    font-size: 20px;
    padding: 0 10px;
    border-left: 5px solid #ff6701;
    margin-bottom: 10px;
    margin-left: -10px;
    line-height: 40px;
}
.order_evaluate_wp {
    display: flex;
    .order_evaluate {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 46px;
        .order_ {
            width: 134px;
            height: 126px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .evaluate_texta {
        width: 595px;

        /deep/.el-textarea__inner {
            height: 154px !important;
        }
    }
}
.eva_fen {
    display: flex;
    margin-top: 112px;
    margin-bottom: 67px;
    span {
        width: 160px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 22px;
    }
}
.eva_btn {
    text-align: center;
}
.evl_wp {
    background-color: #fff;
    padding: 30px;
    margin-top: 20px;
    height: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/evl.vue